package com.wintermar.inspection.core.ui.theme

import androidx.compose.foundation.text.selection.LocalTextSelectionColors
import androidx.compose.foundation.text.selection.TextSelectionColors
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Typography
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.remember
import androidx.compose.runtime.staticCompositionLocalOf
import com.wintermar.inspection.core.ui.theme.color.DefaultThemeColor
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor

data class AppTheme(
    val color: ThemeColor,
    val dimension: AppDimension,
    val textStyle: AppTextStyle,
    val typography: Typography
)

val DefaultTypography = Typography()
val DefaultAppTheme = AppTheme(
    color = DefaultThemeColor,
    dimension = AppDimension(),
    textStyle = AppTextStyle(appTypography = DefaultTypography),
    typography = DefaultTypography
)

val LocalAppTheme = staticCompositionLocalOf { DefaultAppTheme }

@Composable
fun AppTheme(content: @Composable () -> Unit) {
    // Build the runtime theme using composable AppTypography inside composition
    val runtimeTheme = AppTheme(
        color = DefaultThemeColor,
        dimension = AppDimension(),
        textStyle = AppTextStyle(appTypography = AppTypography),
        typography = AppTypography
    )

    val m3ColorScheme = lightColorScheme(
        primary = runtimeTheme.color.surface.brand.primary.default,
        secondary = runtimeTheme.color.surface.brand.secondary.default,
        onSurfaceVariant = runtimeTheme.color.surface.brand.primary.default,
        surfaceContainerHigh = runtimeTheme.color.surface.normal
    )

    val textSelectionColors = remember {
        TextSelectionColors(
            handleColor = runtimeTheme.color.surface.brand.primary.default,
            backgroundColor = runtimeTheme.color.surface.brand.primary.default.copy(alpha = 0.4f)
        )
    }

    CompositionLocalProvider(
        LocalAppTheme provides runtimeTheme,
        LocalTextSelectionColors provides textSelectionColors
    ) {
        MaterialTheme(
            colorScheme = m3ColorScheme,
            typography = AppTypography,
            content = content
        )
    }
}
